import React from 'react';
import EclipseLoading from '../../UI/eclipse-loading/eclipse-loading';

import styles from './styles.module.scss';

function Loading({ title, subtitle }) {
  return (
    <div className={styles.container}>
      <EclipseLoading />
      <h3 className="mt-5">{title}</h3>
      <h4 className="mt-4">{subtitle}</h4>
    </div>
  );
}

export default React.memo(Loading);
